import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';

// --- Proxy t() for pre-init calls ---
let i18nextInitialized = false;
let elementsAwaitingTranslation = new Set();
let thirdPartyInitQueue = [];

function proxyT(key, options = {}) {
  let element = null;
  if (options.targetElementId) {
    element = document.getElementById(options.targetElementId);
  }
  if (i18nextInitialized) {
    const translated = i18next.t(key, options);
    if (element) element.innerText = translated;
    return translated;
  } else {
    const initialValue = options.defaultValue || key;
    if (element) {
      element.innerText = initialValue;
      // Store the translation key as data attribute for later use
      element.setAttribute('data-i18n-key', key);
      elementsAwaitingTranslation.add(element);
    }
    return initialValue;
  }
}
proxyT._proxyActive = true;
window.t = proxyT;

// --- Allow registering callbacks for when i18next is ready ---
window.onI18nextReady = function(cb) {
  if (i18nextInitialized) cb();
  else thirdPartyInitQueue.push(cb);
};

// --- Initialize i18next ---
const config = window.i18nConfig;
const { initialLanguage = 'en', i18nPaths = {} } = config || {};

const javascriptI18n = i18n.createInstance();

// --- Initialize i18next ---
javascriptI18n
  .use(HttpBackend)
  .init({
    lng: initialLanguage,
    fallbackLng: 'en',
    backend: {
      loadPath: (lng, ns) => {
        const path = i18nPaths[lng] || i18nPaths['en'] || '';
        // If no valid path, return a path that will fail to load
        return path || '/invalid-path-force-fallback';
      },
    },
  }).then(() => {
    // Mark as completed
    i18nextInitialized = true;
    window.i18next = javascriptI18n;
    window.t = javascriptI18n.t.bind(javascriptI18n);
    window.i18nInitializing = false;

    // Update any elements that were waiting for translation
    elementsAwaitingTranslation.forEach(element => {
      if (!document.body.contains(element)) return;
      element.innerText = javascriptI18n.t(element.getAttribute('data-i18n-key') || '');
    });
    elementsAwaitingTranslation.clear();

    // Run queued callbacks
    while (thirdPartyInitQueue.length > 0) {
      try { 
        thirdPartyInitQueue.shift()(); 
      } catch (e) { 
        console.error(e); 
      }
    }

    console.log('i18next global initialized successfully');
  });

// Export the t function for ES6 imports
export const t = (key, options = {}) => {
  if (i18nextInitialized) {
    return javascriptI18n.t(key, options);
  } else {
    return options.defaultValue || key;
  }
};

export default javascriptI18n; 